RECURRENCE_TYPES = ['new', 'active', 'returned', 'cold', 'dead']
CHANNELS_TYPES =  ['send_push', 'send_whatsapp', 'send_sms', 'send_telegram', 'send_vk']
App.AdvertsTableComponent = Em.Component.extend
  classNames: ['adverts-table']

  sort: 'created_at'
  sortAscending: true
  sortByName          : Em.computed.equal 'sort', 'name'
  sortByRecurrence    : Em.computed.equal 'sort', 'recurrence'
  sortByClientTags    : Em.computed.equal 'sort', 'client_tags'
  sortByRestaurants   : Em.computed.equal 'sort', 'restaurants'
  sortByChannels      : Em.computed.equal 'sort', 'channels'
  sortByCreatedAt     : Em.computed.equal 'sort', 'created_at'

  recurrence: (->
    RECURRENCE_TYPES.map (el) =>
      id:  el
      name: Em.I18n.t "clients.recurrence_label.#{el}"
      checked: false
  ).property('recurrence')


  isFiltersVisible: false
  selectedRestaurants: []
  selectedRecurrence: []
  selectedClientTags: []
  selectedChannels: []
  createdAtFrom: null
  createdAtTill: null
  searchQuery: ''

  debouncedSearchQuery: null
  debouncedSearchQueryTimeout: null

  debounceSearchQuery: (->
    Em.run.cancel @get('debouncedSearchQueryTimeout')
    if Em.isEmpty(@get('searchQuery'))
      @set('debouncedSearchQuery','')
      return
    @set('debouncedSearchQueryTimeout', Em.run.later @, ->
      @set('debouncedSearchQuery', @get('searchQuery'))
      @set('debouncedSearchQueryTimeout',null)
    , 2000)
  ).observes('searchQuery')


  createdAtFromOWBinding: Em.Binding.oneWay('createdAtFrom')
  createdAtTillOWBinding: Em.Binding.oneWay('createdAtTill')
  
  tableHeadings: (->
    headings = [
      { sortBy: 'name', heading: 'adverts.table.content.name' },
      { sortBy: 'recurrence', heading: 'adverts.table.content.recurrence' },
      { sortBy: 'client_tags', heading: 'adverts.table.content.client_tags' },
      { sortBy: 'restaurants', heading: 'adverts.table.content.restaurants' },
      { sortBy: 'channels', heading: 'adverts.table.content.channels' },
      { sortBy: 'created_at', heading: 'adverts.table.content.created_at' },
    ]

    headings.forEach (heading) =>
      camelizedHeading = _.camelCase(heading.sortBy)
      formattedHeading = "#{camelizedHeading.charAt(0).toUpperCase()}#{camelizedHeading.slice(1)}"
      heading.sorted = @get("sortBy#{formattedHeading}")
    headings
  ).property('sort')

  filterQueryAdverts: (-> 
    # Получаем значения выбранных фильтров
    selectedClientTagsIds = @get('selectedClientTags').map (r) -> Em.get(r, 'id')
    selectedRecurrence = @get('selectedRecurrence').map (r) -> Em.get(r, 'id')
    restaurantIds = @get('selectedRestaurants').map (r) -> Em.get(r, 'id')
    selectedChannels = @get('selectedChannels').map (c) -> Em.get(c, 'id')
    searchQuery = @get('debouncedSearchQuery')?.toLowerCase()
    createdAtFrom = @get('createdAtFrom')
    createdAtTill = @get('createdAtTill')

    # Получаем оригинальный массив промо
    adverts = @get('mappedAdverts') || []

    # Применяем фильтры
    filteredAdverts = adverts.filter (advert) ->
      matchedFilters = []
      if !Em.isEmpty(selectedRecurrence)
        matchedFilters.push(selectedRecurrence.some (type) => advert.get('recurrence')?.includes(type))
      # Фильтрация по источникам заказа
      if !Em.isEmpty(selectedClientTagsIds)
        matchedFilters.push(advert.get('tagsIds')?.some (tagId) => selectedClientTagsIds.includes(tagId))

      # Фильтрация по ресторанам
      if !Em.isEmpty(restaurantIds)
        matchedFilters.push(restaurantIds.some (id) => advert.get('restaurantsIds')?.includes(id))

      # Фильтрация по строке поиска
      if !Em.isEmpty(searchQuery)
        advertName = advert.get('name')?.toLowerCase() || ''
        matchedFilters.push(advertName.includes(searchQuery))

      # Фильтрация по диапазону дат
      if !Em.isEmpty(createdAtFrom) or !Em.isEmpty(createdAtTill)
        advertCreatedAt = advert.get('created_at')
        if not advertCreatedAt
          matchedFilters.push(false)
        else
          matchedFilters.push(moment(advertCreatedAt).isBetween(createdAtFrom || moment().toISOString(), createdAtTill || moment().toISOString(), null, '[]'))

      # Проверяем, соответствует ли элемент всем фильтрам
      matchedFilters.every (el) => el

    # Возвращаем отфильтрованный массив
    filteredAdverts
  ).property(
    'selectedClientTags.[]'
    'mappedAdverts.[]', 
    'selectedRecurrence.[]', 
    'selectedRestaurants.[]', 
    'debouncedSearchQuery', 
    'createdAtFrom', 
    'createdAtTill'
  )



  didInsertElement: ->
    @send('sortBy', @get('sort'))

  mappedAdverts: (->
    adverts = @get('adverts')
    return [] unless adverts
    adverts.forEach (advert) =>
      channelsText = CHANNELS_TYPES.filter (type) =>
        advert.get(type)
      .map (type) =>
        Em.I18n.t "adverts.delivery.#{type}.label"
      .join(', ')
      advert.set('channelsText', channelsText)

      advert.get('client_tags').then (tags) =>
        return unless tags
        tagsText = tags.map (tag) =>
          tag.get('name')
        .join(', ')
        tagsIds = tags.map (tag) =>
          tag.get('id')

        advert.set('tagsText', tagsText)
        advert.set('tagsIds', tagsIds)

      advert.get('restaurants').then (rests) =>
        return unless rests
        restaurantsText = rests.map (rest) =>
          rest.get('name')
        .join(', ')
        restaurantsIds = rests.map (rest) =>
          rest.get('id')

        advert.set('restaurantsText', restaurantsText)
        advert.set('restaurantsIds', restaurantsIds)

      if advert.get('recurrence')
        advert.set('recurrenceText', 
          advert.get('recurrence').map (item) =>
            Em.I18n.t "clients.recurrence_label.#{item}"
          .join(', ')
        )

    adverts
  ).property('adverts.[]')


  actions:
    sortBy: (propertyName) ->
      currentSort = @get 'sort'
      sortAscending = @get 'sortAscending'

      # Если уже сортируем по текущему столбцу, инвертируем направление
      if currentSort is propertyName
        @toggleProperty 'sortAscending'
        sortAscending = @get 'sortAscending'
      else
        # Устанавливаем новый ключ сортировки и по умолчанию сортируем по возрастанию
        @set 'sort', propertyName
        @set 'sortAscending', true
        sortAscending = true

      # Получаем список промо и сортируем их
      adverts = @get 'mappedAdverts'

      # Обрабатываем сортировку, учитывая случаи, когда значение отсутствует
      sortedAdverts = _.sortBy(adverts.toArray(), (advert) ->
        value = null
        switch propertyName
          when 'channels'
            value = CHANNELS_TYPES.filter (type) => advert.get(type)
          when 'client_tags'
            value = advert.get('tagsIds')
          when 'restaurants'
            value = advert.get('restaurantsIds')
          else
            value = advert.get(propertyName) 
        # Устанавливаем значение для отсутствующих данных, чтобы они сортировались корректно
        if value? then value else (if sortAscending then Infinity else -Infinity)
      )

      # Если требуется сортировка по убыванию, инвертируем массив
      unless sortAscending
        sortedAdverts = sortedAdverts.reverse()

      # Обновляем список промо
      @set 'mappedAdverts', sortedAdverts

      false

    openAdvert: (advert) ->
      @sendAction('openAdvert', advert)
      false

    toggleFilters: ->
      @toggleProperty('isFiltersVisible')
      false

    updateCreatedAtFrom: (val) ->
      @set('createdAtFrom', val)
      false

    updateCreatedAtTill: (val) ->
      @set('createdAtTill', val)
      false



